import TransactionMonitoringIntegrations from '@/models/Settings/Institutions/Integrations/TransactionMonitoringIntegrations';

export default (transactionMonitoringIntegration: TransactionMonitoringIntegrations) => {
    let returnVal = "Undefined";
    switch (transactionMonitoringIntegration) {
        case TransactionMonitoringIntegrations.Comply:
            returnVal = "Comply"
            break;
        case TransactionMonitoringIntegrations.Swisscom:
            returnVal = "Swisscom"
            break;
        case TransactionMonitoringIntegrations.HawkAI:
            returnVal = "Hawk AI"
            break;
    }
    return returnVal;
}